<template>
    <li class="my-2 md:my-0">
        <a href="#"
           @click.prevent="$emit('click', $event)"
           class="block py-1 md:py-3 pl-1 align-middle text-gray-600 no-underline hover:text-indigo-400"
           :class="{'text-indigo-400': active}"
        >
            <fa :icon="icon"
                class="mr-3"
            />

            <span class="w-full inline-block pb-1 md:pb-0 text-sm"
                  v-text="title">
            </span>
        </a>
    </li>
</template>

<script>
    export default {
        props: {
            icon: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
